export var SENTRY_RELEASE = "386a56fa1a84b19f997c9df0f2bfd5f7499d86ce";
